/* eslint-disable jira/filename-case */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import { createStore, createActionsHook, type Action } from '@atlassian/react-sweet-state';
import { createSelectorHook } from '@atlassian/react-sweet-state/src/components/hook.tsx';

type State = {
	shouldTriggerCacheRefresh: boolean;
	shouldTriggerGroupByCacheRefresh: boolean;
	shouldTriggerWorkflowCacheRefresh: boolean;
};

const actions = {
	triggerListViewCacheRefresh:
		(): Action<State> =>
		({ setState, getState }) => {
			setState({
				...getState(),
				shouldTriggerCacheRefresh: true,
			});
		},
	triggerListViewGroupByCacheRefresh:
		(): Action<State> =>
		({ setState, getState }) => {
			setState({
				...getState(),
				shouldTriggerGroupByCacheRefresh: true,
			});
		},
	triggerWorkflowCacheRefresh:
		(): Action<State> =>
		({ setState, getState }) => {
			setState({
				...getState(),
				shouldTriggerWorkflowCacheRefresh: true,
			});
		},
	resetRefreshCacheTrigger:
		(): Action<State> =>
		({ setState, getState }) => {
			setState({
				...getState(),
				shouldTriggerCacheRefresh: false,
			});
		},
	resetListViewGroupByRefreshCacheTrigger:
		(): Action<State> =>
		({ setState, getState }) => {
			setState({
				...getState(),
				shouldTriggerGroupByCacheRefresh: false,
			});
		},
	resetWorkflowCacheRefreshTrigger:
		(): Action<State> =>
		({ setState, getState }) => {
			setState({
				...getState(),
				shouldTriggerWorkflowCacheRefresh: false,
			});
		},
};

const ListViewTriggerCacheRefreshStore = createStore<State, typeof actions>({
	initialState: {
		shouldTriggerCacheRefresh: false,
		shouldTriggerGroupByCacheRefresh: false,
		shouldTriggerWorkflowCacheRefresh: false,
	},
	actions,
	name: 'list-view-trigger-cache-refresh-store',
});

export const useListViewRefreshCacheActions = createActionsHook(ListViewTriggerCacheRefreshStore);
export const useListViewRefreshCacheStore = createSelectorHook(ListViewTriggerCacheRefreshStore);
